import { Nilable } from "@shared/utils";

export interface IEnvioUltimaHoraDTO {
    datetime: string;
    count: number;
    series: string;
}

export class EnvioUltimaHoraDTO {
    public fechaHoraString = "";
    public cantidadRespuestas = 0;
    public envios: number[] = [];

    constructor(json: Nilable<Partial<IEnvioUltimaHoraDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IEnvioUltimaHoraDTO>) {
        if (json.datetime != null) {
            this.fechaHoraString = json.datetime;
        }
        if (json.count != null) {
            this.cantidadRespuestas = json.count;
        }
        if (json.series != null) {
            this.envios = json.series.split(",").map(Number);
        }
    }

    public toJSON(): IEnvioUltimaHoraDTO {
        return {
            series: this.envios.join(","),
            count: this.cantidadRespuestas,
            datetime: this.fechaHoraString
        };
    }
}
